// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import ReimbursementSummary, {getDefaultState as getReimbursementSummaryDefaultState} from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary';
import SelectedPostingDate, {getDefaultState as getSelectedPostingDateDefaultState} from './selected-posting-date';
import t from 'tcomb';

const ReimbursementSummaryState = t.struct({
    busyCounter: BusyCounter,
    isInitialLoad: t.Boolean,
    leadAccounts: ReimbursementSummary,
    selectedLeadAccount: t.String,
    selectedPostingDate: SelectedPostingDate,
    selectedValue: t.String
}, {
    name: 'ReimbursementSummaryState',
    strict: true
});

export const getDefaultState = () =>
    new ReimbursementSummaryState({
        busyCounter: getBusyCounterDefaultState(),
        isInitialLoad: true,
        leadAccounts: getReimbursementSummaryDefaultState(),
        selectedLeadAccount: '',
        selectedPostingDate: getSelectedPostingDateDefaultState(),
        selectedValue: ''
    });

export default ReimbursementSummaryState;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/state/index.js